// extracted by mini-css-extract-plugin
export default {"install":"install_install"};